import {DefaultInfoV1Props} from "@models/DefaultProps.ts";
import {ILog} from "@models/seguranca/ILog.ts";
import {TableCell, TableRow, Typography} from "@mui/material";
import {UsuarioTypo} from "@components/usuario/UsuarioTypo.tsx";
import React, {useEffect, useState} from "react";
import {ToDateTimeDefault} from "@shared/MathHelp.ts";

interface UsuarioLogItemRowProps extends DefaultInfoV1Props<ILog | string> {
}

export function UsuarioLogItemRow(props: UsuarioLogItemRowProps) {
    const [item, setItem] = useState<ILog | undefined>();

    useEffect(() => {
        if (props.value && typeof props.value === "object")
            setItem(props.value as ILog)
    }, [props.value]);

    return (item != null && <TableRow>
        <TableCell>
            <UsuarioTypo usuarioId={item.usuarioOrigemId}/></TableCell>
        <TableCell>{ToDateTimeDefault(item.dataLog)}</TableCell>
        <TableCell><Typography noWrap maxWidth={500}>{item.detalhes}</Typography></TableCell>
    </TableRow>)
}